import { type ICondoEvent, ProcessType } from '@condo/domain';
import { invoiceStateColors, statesColorMap } from './color-mappers';

export const stateCssDecorator = (event: ICondoEvent) => {
    let processType: ProcessType;

    if (event.payload?.invoice) {
        return invoiceStateColors[event?.payload?.invoice?.state];
    }

    if (event.processType === 'Sourcing' && event.processId) {
        processType = ProcessType.Sourcing;
    } else if (event.processType === 'Purchasing' && event.processId) {
        processType = ProcessType.Purchasing;
    } else if (event.processType === 'Renovation' && event.processId) {
        processType = ProcessType.Renovation;
    } else if (event.processType === 'Renting' && event.processId) {
        processType = ProcessType.Renting;
    } else if (event.processType === 'Selling' && event.processId) {
        processType = ProcessType.Selling;
    }

    return statesColorMap[processType]?.[event?.payload?.state];
};
